import React from "react";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useSelectorDataConfigurator } from "~/hooks/selectorDataConfigurator";
import type { Report } from "~/pages/Editor/EditorReports/ui/TemplatesOfReports/ManageReportForm/index";
import { useGetIndicatorsForSelectLazyQuery } from "~/schemas/generated/graphql";
import { Field } from "~/shared/ui/Field";

interface ReportIndicatorsFormProps {
  control: Control<Report>;
  error?: string;
  disabled: boolean;
}

const ReportIndicatorsForm = ({
  control,
  error,
  disabled,
}: ReportIndicatorsFormProps) => {
  const { t } = useTranslation();

  const {
    rowsForSelect,
    introspectionHandler,
    searchValue,
    dataRequestLoading,
  } = useSelectorDataConfigurator({
    queryGenerator: useGetIndicatorsForSelectLazyQuery,
    responseDataGetterString: "IndicatorGetter.getIndicators.items",
    searchConfig: (searchText) => ({ searchText }),
    customValueHandler: ({ id, nameRu }) => {
      return {
        value: id,
        label: `(${id}) ${nameRu}`,
      };
    },
  });

  return (
    <Field
      type="select"
      name="indicators"
      control={control}
      label={t("report_list.indicators")}
      options={rowsForSelect}
      mode="multiple"
      labelInValue
      showSearch
      filterOption={false}
      onSearch={searchValue}
      onPopupScroll={introspectionHandler}
      loading={dataRequestLoading}
      maxTagCount="responsive"
      error={error}
      disabled={disabled}
    />
  );
};

export default ReportIndicatorsForm;
